import React from "react";

import { useIsFeatureFlagOn } from "../hooks/use-is-feature-flag-on";
import { FeatureFlagIDs } from "../models/config";

interface FeatureFlagToggleProps {
  flag: FeatureFlagIDs;
  children: React.ReactNode;
  fallback?: React.ReactNode;
  isInverted?: boolean;
  isDevelopmentBypassAllowed?: boolean;
}

export const FeatureFlagToggle: React.FC<FeatureFlagToggleProps> = ({
  flag,
  children,
  fallback = null,
  isInverted = false,
  isDevelopmentBypassAllowed = true,
}) => {
  const { isOn, isLoading } = useIsFeatureFlagOn({ flag, isInverted, isDevelopmentBypassAllowed });

  if (isLoading) {
    return <></>;
  }

  return <>{isOn ? children : fallback}</>;
};
